import React from "react";
import { Link } from "react-router-dom";

import "./styles/footer.css";

const Footer = () => {
	return (
		<React.Fragment>
			<div className="footer">
				<div className="footer-links">
					<ul className="footer-nav-link-list">
						<li className="footer-nav-link-item">
							<Link to="/">Ínicio</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/about">Sobre</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/projects">Projetos</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/articles">Artigos</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/contact">Contato</Link>
						</li>
					</ul>
				</div>

				<div className="footer-credits">
					<div className="footer-credits-text">
						<p>Knowledge is power and sharing knowledge is empowering</p>
						<p>© 2024 Doni-zetti-De-Souza:dev/eng/traveler. </p>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Footer;
